var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkrill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "227px",
    height: "78px",
    viewBox: "0 0 227 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "skrill-logo-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "27.0439582%",
    y1: "0%",
    x2: "79.2629133%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B195F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C255B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "skrill-logo-web-1-rgb",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.891,19.153 C168.032,19.153 172.199,14.988 172.199,9.852 C172.199,4.713 168.032,0.544 162.891,0.544 C157.756,0.544 153.591,4.713 153.591,9.852 C153.591,14.988 157.756,19.153 162.891,19.153 L162.891,19.153 Z M91.604,24.176 C91.184,25.231 88.161,33.77 80.85,42.62 L80.85,4.779 L61.37,8.629 L61.37,77.22 L80.85,77.22 L80.85,56.018 C86.492,64.48 89.278,77.22 89.278,77.22 L112.611,77.22 C110.303,67.625 100.207,49.933 100.207,49.933 C109.268,38.445 113.248,26.204 113.881,24.176 L91.604,24.176 L91.604,24.176 Z M142.816,23.46 C125.368,24.02 116.511,31.848 116.511,47.409 L116.511,77.22 L135.546,77.22 L135.546,52.91 C135.546,43.592 136.766,39.598 147.823,39.217 L147.823,23.733 C145.962,23.338 142.816,23.46 142.816,23.46 L142.816,23.46 Z M28.7,31.729 C26.314,31.572 20.79,31.215 20.79,26.242 C20.79,20.241 28.743,20.241 31.726,20.241 C36.971,20.241 43.764,21.791 48.615,23.242 C48.615,23.242 51.321,24.196 53.624,25.173 L53.838,25.231 L53.838,8.796 L53.544,8.709 C47.819,6.706 41.162,4.779 28.82,4.779 C7.54,4.779 0,17.176 0,27.796 C0,33.918 2.624,48.326 26.995,49.988 C29.061,50.115 34.544,50.431 34.544,55.57 C34.544,59.813 30.055,62.315 22.505,62.315 C14.231,62.315 6.205,60.205 1.33,58.204 L1.33,75.131 C8.628,77.044 16.855,78 26.497,78 C47.304,78 56.623,66.271 56.623,54.646 C56.623,41.465 46.195,32.901 28.7,31.729 L28.7,31.729 Z M153.455,77.22 L172.336,77.22 L172.336,24.236 L153.455,24.236 L153.455,77.22 Z M207.888,8.157 L207.888,77.22 L226.772,77.22 L226.772,4.779 L207.888,8.157 L207.888,8.157 Z M180.334,8.157 L199.2,4.779 L199.2,77.22 L180.334,77.22 L180.334,8.157 L180.334,8.157 Z",
    id: "Fill-1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkrill);
export default __webpack_public_path__ + "static/media/skrill.7f45d6ee5e759e057c9704665f2d9d84.svg";
export { ForwardRef as ReactComponent };